import type { SubListType } from '@/domains/docs-site/ApiFolderSubListBuilder';
import type { ApiFolderServerType } from '@/services/api-folder/apiFolder';
import type { CustomEndpointServerType } from '@/services/custom-endpoint/customEndpoint';
import type { DataSchemaServerType } from '@/services/data-schema/dataSchema';
import type { DocServerType } from '@/services/doc/doc';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import type { SecuritySchemeServerType } from '@/services/security-scheme/securityScheme';
import type { WebSocketApiServerType } from '@/services/websocket-api/webSocketApi';
import type { InheritAuthInfoResult } from '@tarslib/base/lib/AuthBuilder';
import type { ModelType } from '@tarslib/types/lib/common';
import type { IHttpFolderMap } from '@tarslib/types/lib/httpFolder';
import type { ApiFieldList } from './ApiFieldList';
import type { Any } from './any';

export type ResourceDocData = {
  type: ModelType.Doc;
  data: DocServerType;
  extraData: {
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
  };
};

export type ResourceApiFolderData = {
  type: ModelType.ApiFolder;
  data: ApiFolderServerType;
  extraData: {
    subList: SubListType[];
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
  };
};

export type ResourceCustomEndpointData = {
  type: ModelType.CUSTOM_ENDPOINT;
  data: CustomEndpointServerType;
  extraData: {
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
  };
};

export type ResourceHttpApiData = {
  type: ModelType.HttpApi;
  data: HttpApiServerType;
  extraData: {
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
    apiFolderMap: IHttpFolderMap;
    requestCollection: typeof Any;
    defaultRequestSampleCode:
      | {
          code: string;
          language: string;
          variant: string;
          codeBlockLanguage: string;
        }
      | undefined;
    serverId: string;
    securitySchemeMap: SecuritySchemeServerType;
    inheritAuthInfo: InheritAuthInfoResult | undefined | null;
    oasExtensions: string;
  };
};

export type ResourceWebSocketApiData = {
  type: ModelType.WebSocketApi;
  data: WebSocketApiServerType;
  extraData: {
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
    apiFolderMap: IHttpFolderMap;
  };
};

export const ResourceNotFound = 'NotFound' as const;

export type ResourceNotFoundData = {
  type: typeof ResourceNotFound;
  data: undefined;
  extraData: {
    apiFieldList: ApiFieldList[];
    dataSchemaDefinitions: DataSchemaServerType;
  };
};

export type ResourceData =
  | ResourceNotFoundData
  | ResourceDocData
  | ResourceApiFolderData
  | ResourceCustomEndpointData
  | ResourceHttpApiData
  | ResourceWebSocketApiData;
